<template>
  <div :class="classList" :title="name">
    {{ initials }}
  </div>
</template>

<script>
import { AVATAR_SIZES } from '../constants.js'
export default {
  name: 'Person',
  props: {
    name: {
      type: String,
      required: true,
    },
    size: {
      type: Number,
      default: AVATAR_SIZES.MEDIUM,
      validator: value => Object.values(AVATAR_SIZES).includes(value),
    },
  },
  computed: {
    initials() {
      const { name } = this;
      const words = name.toLocaleUpperCase().split(' ');
      const firstLetter = words[0].charAt(0);
      const lastLetter = words[words.length - 1].charAt(0);
      return words.length > 1
        ? firstLetter + lastLetter
        : firstLetter;
    },
    classList() {
      const { size } = this;
      return [
        'person',
        `person--size-${size}`,
      ];
    },
  }
}
</script>

<style scoped>
.person {
  display: inline-block;
  flex-shrink: 0;
  width: var(--size);
  height: var(--size);
  line-height: calc(var(--size) - 2px);
  font-size: calc(var(--size) * .6);
  border-radius: 100%;
  background-color: #6d547e;
  color: white;
  text-align: center;
  border: 1px solid;
}
.person--size-30 {
  --size: 30px;
}
.person--size-45 {
  --size: 45px;
}
.person--size-60 {
  --size: 60px;
}
</style>
